import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import classNames from 'classnames'
import './ProductPackage.css'

class ProductPackage extends Component {

  setNewValue = (type, value, index = null) => {
    const {
        onChange,
        ...rest
    } = this.props

    let payload = { ...rest }
    payload = {...payload, [type]: value}
    
    onChange(payload)
  }
    
    render() {
        const {
            index,
            title,
            enabled,
            type,
            price,
            editablePrice,
            currency = '',
            description,
            togglePackage,
            custom = false,
            disableSelect = undefined,
            children,
        } = this.props
        
        const cls = classNames('package', {'package__open': enabled, 'package__closed': !enabled})
        
        if(!enabled){
            return (
                <div className={cls}>
                    <Row className="form--row">
                        <Col xs={12}>
                            <div className="form-group">
                                <label className={classNames('label', {'label__disabled': disableSelect})}><input disabled={disableSelect} checked={enabled} onChange={ event => togglePackage({type: type}) } type="checkbox" />&nbsp; {custom ? type : title}</label>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        }
        
        return (
            <div className={cls}>
                <Row className="form--row">
                    <Col xs={12}>
                        <div className="form-group">
                            <label><input checked={enabled} onChange={ event => togglePackage({type: type}) } type="checkbox" />&nbsp; {custom ? type : title}</label>
                        </div>
                            {
                                custom && (
                                    <div className="form-group">
                                        <label className="label" htmlFor={`title-${index}`}>Package title</label>
                                        <input
                                            onChange={event => this.setNewValue('title', event.target.value)}
                                            required
                                            type="text" 
                                            id={`title-${index}`} 
                                            name={`title-${index}`} 
                                            defaultValue={title}
                                        />
                                    </div>
                                )
                            }
                    </Col>
                </Row>
                <Row className="form--row">
                  <Col xs={12}>
                    <div className="form-group">
                      <label className="label" htmlFor={`description-${index}`}>
                        Package description
                      </label>
                      <textarea 
                        required
                        onChange={event => this.setNewValue('description', event.target.value)} 
                        id={`description-${index}`} 
                        name={`description-${index}`} 
                        defaultValue={description}
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="form--row">
                    <Col xs={12}>
                    <div className="form-group">
                        <label className="label" htmlFor={`price`}>Package price</label>
                        <br />
                        <span data-postfix={currency}>
                            <input 
                                onChange={event => this.setNewValue('price', event.target.value)}
                                required
                                max={10000}
                                type="number" 
                                id={`price`} 
                                name={`price`} 
                                defaultValue={price} 
                                disabled={editablePrice === false}
                            />
                        </span>
                    </div>
                    </Col>
                </Row>
                { children }
            </div>
        )
    }
}

export default ProductPackage



// WEBPACK FOOTER //
// ./src/components/ProductPackages/ProductPackage.js